import { render, staticRenderFns } from "./ResAndTxt.vue?vue&type=template&id=75885e40&scoped=true"
import script from "./ResAndTxt.vue?vue&type=script&lang=js"
export * from "./ResAndTxt.vue?vue&type=script&lang=js"
import style0 from "./ResAndTxt.vue?vue&type=style&index=0&id=75885e40&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75885e40",
  null
  
)

export default component.exports